export enum SeverityLevel {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL',
  SPOT = 'SPOT',
  NOTE = 'NOTE',
}
export interface Disruption {
  disruption: string;
  disruption_detail: string;
  entry_time: string;
  resolution_time: string;
  updater_name: string;
  severity: SeverityLevel;
  disruption_id: string;
  group_id: string;
  grouped: Array<Omit<Disruption, 'grouped'>>;
}
